/*
    URLs for the REST API
*/
/* eslint-disable no-multi-spaces */

export const ROOT_URL =
  process.env.NODE_ENV === "production"
    ? process.env.VUE_APP_PRODUCTION
    : process.env.VUE_APP_localUrl
    ? process.env.VUE_APP_localUrl
  : "http://127.0.0.1:8000/";
export const WEBSOCK_URL = ROOT_URL.replace("http", "ws").replace(
  /\d{4}/,
  "8002"
);
export const API_ROOT = [ROOT_URL, "api"].join("");
export const CDG_API_ROOT = [ROOT_URL, "cdg"].join("");
export const CDG_API = [CDG_API_ROOT, "api"].join("/");
export const FETCH_CATS = [API_ROOT, "fetch_cats"].join("/");
export const NODE_CHILDREN = [API_ROOT, "node_children"].join("/");
export const ACCESS_API_ROOT = [ROOT_URL, "access"].join("");
export const ACCESS_API = [ACCESS_API_ROOT, "api"].join("/");
export const NODE_API = [API_ROOT, "node"].join("/");
export const SCORE_API = [API_ROOT, "score"].join("/");
export const ORDER_API_ROOT = [ROOT_URL, "order"].join("");
export const ORDER_API = [ORDER_API_ROOT, "api"].join("/");

/*
 * MAKE_STATE takes optional parameters:
 * No parameters: Make state for all cartegories.
 * [array of cats]: Make state for listed categories.
 * [array of cats]/index: Make stae for listed categories against an index case.
 */
export const MAKE_STATE = [CDG_API, "make_state"].join("/");

// Same options as for MAKE_STATE only generate ransom cases.
export const GEN_STATE = [CDG_API, "gen_state"].join("/");
/*
 * SUBSPACE_CATS/state_id
 * Returns list of categories in the state.
 */
export const SUB_SPACE_CATS = [CDG_API, "sub_space_names"].join("/");

/*
 * SCORE/state_id/[array of cats]
 * Returns scores for listed cats in state.
 */
export const SCORE = [CDG_API, "score"].join("/");

/*
 * FACTORS/state_id/cat/[array of scores]
 * Returns common factors with given scores for a category
 */
export const FACTORS = [CDG_API, "factors"].join("/");

export const DataSets = {
  Mock: {
    USERS: "users",
    RECORDS: "mock_records",
    CATEGORIES: "mock_categories",
    TEMPLATES: "mock_templates",
    UOMS: "uoms",
    GLOSSARY: "glossary",
    TYPE_PROTOS: "type_protos"
  },
  Mimic: {
    USERS: "users",
    RECORDS: "records",
    CATEGORIES: "categories",
    TEMPLATES: "templates",
    UOMS: "uoms",
    GLOSSARY: "glossary",
    TYPE_PROTOS: "type_protos"
  },
  Test: {
    USERS: "users",
    RECORDS: "test_records",
    CATEGORIES: "test_categories",
    TEMPLATES: "test_templates",
    UOMS: "uoms",
    GLOSSARY: "glossary",
    TYPE_PROTOS: "type_protos"
  }
};

export const COLLECTIONS = DataSets.Test;
